import { i18n } from '@/plugins/i18n'

export const stakeholderStatus = {
                   // user can update data | description
                   // -------------------------------------------------------
    CREATED:    1, // yes                  | when user create or update data
    PENDING:    2, // no                   | while validating data
    ACTIVE:     3, // no                   | when admin accept data
    REJECTED:   4, // yes                  |
    BLOCKED:    5, // no                   |
}

export const stakeholderStatusStr = {
    CREATED:  i18n.t('stakeholder_status.created'),
    PENDING:  i18n.t('stakeholder_status.pending'),
    ACTIVE:   i18n.t('stakeholder_status.active'),
    REJECTED: i18n.t('stakeholder_status.rejected'),
    BLOCKED:  i18n.t('stakeholder_status.blocked'),

    get(status) {
        let status_str = null;

        Object.keys(stakeholderStatus).forEach(function (item) {
            if(stakeholderStatus[item] === status) {
                status_str = stakeholderStatusStr[item];
            }
        })

        return status_str;
    }
}

export const stakeholderVariant = (status) => {
    if(status === stakeholderStatus.ACTIVE) {
        return 'success';
    }

    if( status === stakeholderStatus.CREATED || status === stakeholderStatus.PENDING) {
        return 'warning';
    }

    if(status === stakeholderStatus.REJECTED || status === stakeholderStatus.BLOCKED) {
        return 'danger';
    }

    return 'secondary';
}
